// Countdown: ticks the days/hours/minutes/seconds cells down to the ISO time in data-target.
// When the time passes, the clock hides itself and any [data-countdown-done] message shows.
class Countdown extends HTMLElement {
  #timer = 0;

  connectedCallback() {
    const target = Date.parse(this.dataset.target ?? '');
    if (Number.isNaN(target)) return;
    const cells = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };
    const pad = (n) => String(n).padStart(2, '0');

    const tick = () => {
      const left = Math.max(0, Math.floor((target - Date.now()) / 1000));
      if (cells.days) cells.days.textContent = pad(Math.floor(left / 86400));
      if (cells.hours) cells.hours.textContent = pad(Math.floor((left % 86400) / 3600));
      if (cells.minutes) cells.minutes.textContent = pad(Math.floor((left % 3600) / 60));
      if (cells.seconds) cells.seconds.textContent = pad(left % 60);
      if (left === 0) {
        window.clearInterval(this.#timer);
        const clock = this.querySelector('[data-countdown-clock]');
        const done = this.querySelector('[data-countdown-done]');
        if (clock instanceof HTMLElement) clock.hidden = true;
        if (done instanceof HTMLElement) done.hidden = false;
      }
    };

    tick();
    this.#timer = window.setInterval(tick, 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }
}

if (!customElements.get('s-countdown')) customElements.define('s-countdown', Countdown);
